import styles from "./Background.module.css";
import stripedBlob from "../../assets/images/background/blob1.svg";
import solidBlob from "../../assets/images/background/blob4.svg";
import outlinedBlob from "../../assets/images/background/blob5.svg";

const Background = (props) => {
  return (
    <div className={styles["background"]}>
      <img src={stripedBlob} alt="blob" className={styles["striped-blob"]} />
      <img src={solidBlob} alt="blob" className={styles["solid-blob"]} />
      <img
        src={outlinedBlob}
        alt="blob"
        className={`${styles["outlined-blob"]} ${styles["rotating"]}`}
      />
    </div>
  );
};

export default Background;
